import React from "react";
import { ChartType } from "../../../../Model/Enum/ChartType";

export interface IDropDownOption {
    key: string;
    label: string;
    Id?: string;
    Name?: string;
}

interface IProps {
    dropdownOptions: Array<IDropDownOption>;
    onDropdownSelect: (key: ChartType) => void;
}

export const AddNewChart: React.FC<IProps> = (props: IProps) => {
    const generateDropdownMenu = () => {
        const dropdownOptions = props.dropdownOptions.map((option, index) => (
            <option key={`${index}-${option.key}`} value={option.key}>
                {option.label}
            </option>
        ));
        return (
            <select value="select" onChange={dropDownOnSelect}>
                <option style={{ display: "none" }} value="select">
                    Select element
                </option>
                {dropdownOptions}
            </select>
        );
    };

    const dropDownOnSelect = (event: any) => {
        props.onDropdownSelect(parseInt(event.target.value));
    };

    return (
        <div style={{ float: "right", margin: "10px", minHeight: '220px' }}>
            {generateDropdownMenu()}
        </div>
    );
}
